import { Helmet } from "react-helmet-async";
import { SITE_NAME, SITE_URL, WHATSAPP_DISPLAY } from "../config/site";
import { LEGAL, isLegalFieldSet, isLocalBusinessReady } from "../config/legal";

const DEFAULT_DESC =
  "Noveocard crée des cartes digitales professionnelles premium personnalisées (PVC, NFC) qui connectent votre entreprise à votre univers digital. À partir de 40 € TTC.";

export default function Seo({ title, description = DEFAULT_DESC, path = "/", jsonld = [] }) {
  const fullTitle = title ? `${title} — ${SITE_NAME}` : `${SITE_NAME} — Votre identité. En version digitale.`;
  const url = `${SITE_URL}${path}`;
  const ogImage = `${SITE_URL}/assets/og-image.png`;

  const organization = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: SITE_NAME,
    url: SITE_URL,
    logo: `${SITE_URL}/assets/logo.png`,
    contactPoint: {
      "@type": "ContactPoint",
      telephone: WHATSAPP_DISPLAY.replace(/\s/g, ""),
      contactType: "sales",
      availableLanguage: "fr",
    },
    ...(isLegalFieldSet(LEGAL.email) ? { email: LEGAL.email } : {}),
  };

  const localBusiness = isLocalBusinessReady()
    ? {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        name: LEGAL.operateur,
        url: SITE_URL,
        address: LEGAL.adresse,
        identifier: LEGAL.siret,
      }
    : null;

  const schemas = [organization, ...(localBusiness ? [localBusiness] : []), ...jsonld];

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content="fr_FR" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImage} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      <script type="application/ld+json">{JSON.stringify(schemas)}</script>
    </Helmet>
  );
}
